import { useState } from "react";
import { Eraser, Loader2 } from "lucide-react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { api, errMsg } from "@/lib/api";
import { fmtDate } from "@/components/Bits";

export const KbCleanup = ({ onDone }) => {
  const [list, setList] = useState(null);
  const [busy, setBusy] = useState(false);
  const check = async () => {
    setBusy(true);
    try {
      const r = await api.get("/admin/kb/cleanup");
      if (!r.data.remove.length) toast.success("Nothing to tidy. Those entries are already gone.");
      else setList(r.data.remove);
    } catch (e) { toast.error(errMsg(e)); } finally { setBusy(false); }
  };
  const run = async () => {
    setBusy(true);
    try { const r = await api.post("/admin/kb/cleanup"); toast.success(`Removed ${r.data.removed} ${r.data.removed === 1 ? "entry" : "entries"}`); setList(null); onDone(); }
    catch (e) { toast.error(errMsg(e)); } finally { setBusy(false); }
  };
  return (
    <>
      <Button onClick={check} disabled={busy} variant="outline" data-testid="kb-cleanup-btn" className="rounded-full">
        {busy && !list ? <Loader2 className="h-4 w-4 mr-2 animate-spin" /> : <Eraser className="h-4 w-4 mr-2" />}Tidy up
      </Button>
      <Dialog open={!!list} onOpenChange={(o) => !o && setList(null)}>
        <DialogContent className="max-w-2xl bg-card border-border" data-testid="kb-cleanup-dialog">
          <DialogHeader>
            <DialogTitle className="font-serif text-2xl">{list?.length} {list?.length === 1 ? "entry" : "entries"} will be deleted</DialogTitle>
            <DialogDescription>Check the list below. Nothing is deleted until you confirm.</DialogDescription>
          </DialogHeader>
          <ul className="max-h-[55vh] overflow-y-auto space-y-2" data-testid="kb-cleanup-list">
            {list?.map((e, i) => (
              <li key={e.id} className="rounded-lg border border-border bg-white p-3 text-sm" data-testid={`kb-cleanup-item-${i}`}>
                <div className="font-medium text-navy">{e.title}</div>
                <div className="text-xs text-muted-foreground mt-1">{e.category} · {e.chars} characters · updated {fmtDate(e.updated_at)}</div>
                <div className="text-xs text-pinkb mt-1">{e.reason}</div>
              </li>
            ))}
          </ul>
          <div className="flex justify-end gap-2">
            <Button variant="outline" onClick={() => setList(null)} data-testid="kb-cleanup-cancel" className="rounded-full">Cancel</Button>
            <Button onClick={run} disabled={busy} data-testid="kb-cleanup-confirm" className="rounded-full bg-rose-600 hover:bg-rose-700 text-white">
              {busy && <Loader2 className="h-4 w-4 mr-2 animate-spin" />}Delete {list?.length} {list?.length === 1 ? "entry" : "entries"}
            </Button>
          </div>
        </DialogContent>
      </Dialog>
    </>
  );
};
